import { Chip, Stack } from "@mui/material"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { CustomSkillIndicator } from "./custom-skill-indicator"

export function UnmappedSkillChip({ item, onAdd }) {
    return (
        <Stack direction="row" alignItems="center" spacing={0.5}>
            <Chip
                label={formatLabel(item)}
                icon={<Iconify icon="mdi:plus" />}
                variant="outlined"
                onClick={handleClick}
            />
            <If value={item.isCustomSkill}>
                <CustomSkillIndicator rate={item.customHourlyRate} />
            </If>
        </Stack>
    )

    function handleClick() {
        onAdd(item)
    }
}

function formatLabel(skill) {
    if (skill.skillCode) return `${skill.skillName} (${skill.skillCode})`
    return skill.skillName
}
